import type { Session, Workspace } from "@/api/types";

/** A workspace as a form value: its tenant id, or "root" for the root site's own courses (id null). */
export function workspaceValue(id: number | null | undefined): string {
  return id == null ? "root" : String(id);
}

/** The organisations to choose from (several), or none: the person has one, or isn't on the root site. */
export function workspaceChoices(session: Session | undefined): Workspace[] {
  const options = session?.workspaces ?? [];
  return options.length > 1 ? options : [];
}
